module.exports = __webpack_public_path__ + "img/logo.8dc969e9.png";